import ModelFactory from "@danhoss/model/factory/ModelFactory";

const SecurityContainer = {
    userIsLogged() {
        return !!SecurityContainer.getLoggedUser()
    },

    getLoggedUser() {
        if (typeof LOGGED_USER !== 'undefined' && LOGGED_USER) {
            const factory = new ModelFactory();
            return factory.createModel('UserModel', LOGGED_USER);
        }

        return null;
    }
};

export {
    SecurityContainer
}